import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  switchGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  cardTitle: {
    fontWeight: 500,
    fontSize: "1.5rem",
  },
});

export default function Settings() {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const { t } = useTranslation("settings");

  const currentLang = i18n.language;

  const isEnglish = currentLang.startsWith("en");

  const handleLanguageToggle = async () => {
    const nextLang = isEnglish ? "es" : "en";

    await i18n.changeLanguage(nextLang);
    localStorage.setItem("user-language", nextLang);
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary">
            <Typography variant="h5" className={classes.cardTitle}>
              {t("title")}
            </Typography>
          </CardHeader>

          <CardBody className={classes.switchGroup}>
            <FormControlLabel
              control={
                <Switch
                  checked={isEnglish}
                  onChange={handleLanguageToggle}
                  color="primary"
                />
              }
              label={isEnglish ? "English 🇬🇧" : "Español 🇪🇸"}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}